// Rutas del módulo apariencia: objetos de ruta hijos del Layout (ver src/Routes.js).
const AdministracionApariencia = () => import('@/pages/Administracion/Apariencia/Apariencia.vue');

export default [
    {
        path: '/administracion/apariencia',
        name: 'AdministracionApariencia',
        component: AdministracionApariencia,
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {name: 'Inicio', href: 'Inicio'},
                {name: 'Administración', href: 'Administracion'},
                {name: 'Apariencia'},
            ],
        },
    },
];
